import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

var _actions;

import { GETTER_SETTING_DATA } from "./../constants/types";
import * as types from "@/store/constants/types";
import { iap_service_list } from "@/api/faceServe/index";
import { i18n } from "@/i18n/i18n-setup";
var actions = (_actions = {}, _defineProperty(_actions, types.UPDATE_SERVICE_LIST, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref) {
    var state, commit, serviceResult, list;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit;
            _context.prev = 1;
            _context.next = 4;
            return iap_service_list();

          case 4:
            serviceResult = _context.sent;
            list = serviceResult && serviceResult.data && serviceResult.data.list;
            commit(types.UPDATE_SERVICE_LIST, list);
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _Promise.reject(_context.t0));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.RATE_US, function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref3) {
    var state, commit, getters;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref3.state, commit = _ref3.commit, getters = _ref3.getters;
            return _context2.abrupt("return", new _Promise(function (resolve, reject) {
              try {
                var onResume = function onResume() {
                  // Handle the resume event
                  console.log("onResume");
                  resumeTimeStamp = new Date().valueOf();

                  if (resumeTimeStamp - leavaTimeStamp > limitTime * 1000) {
                    console.log("超过10s");
                    commit(types.UPDATE_RATE_US_STATUS, true);
                    resolve(true);
                  } else {
                    console.log("没有超过10s");

                    _Toast(i18n.t("rate_us.rate_failed_toast"));

                    resolve(false);
                  }

                  document.removeEventListener("resume", onResume, false);
                };

                var leavaTimeStamp = 0;
                var resumeTimeStamp = 0;
                var limitTime = 10;
                document.addEventListener("resume", onResume, false); //setting中取出地址:

                var setting = getters[GETTER_SETTING_DATA];
                var url = setting && setting.client && setting.client.rate_us && setting.client.rate_us.store_url;
                leavaTimeStamp = new Date().valueOf();

                if (url) {
                  cordova.InAppBrowser.open(url, "_system", "location=yes");
                } else {
                  resolve(false);

                  _Toast(i18n.t("rate_us.rate_failed_toast"));
                }
              } catch (e) {
                _Toast(i18n.t("rate_us.rate_failed_toast"));

                resolve(false);
              }
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}()), _actions);
export default actions;